import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './TarifPph29.service'
import Utils from '../../../libs/custom/Utils'

const TarifPph29Form = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})
  const [isEdit, setIsEdit] = useState(false)

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }
      const res = await service.getOne(match.params.id)
      res.data = Utils.formSerialize(res.data)
      setIsEdit(true)
      setData({loading: false, content:res.data})
    }
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      noValidate
      customRules={{
        tahunMulaiBerlaku: 'required|size:4',
        tahunAkhirBerlaku: 'required|size:4'
      }}
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/tarif-pph-29`}
      baseId="mod-form-sample"
      title={t.translate('modules.tarifPph29.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.INPUT_MASK,
          label: 'Mulai Berlaku (Tahun)',
          key: 'tahunMulaiBerlaku',
          width: '49%',
          style: {marginRight: '2%'},
          disabled: isEdit,
          mask: '****',
          alwaysShowMask: true,
          allowNegative: false
        },{
          inputType: inputTypes.INPUT_MASK,
          label: 'Sampai Berlaku (Tahun)',
          key: 'tahunAkhirBerlaku',
          width: '49%',
          disabled: isEdit,
          mask: '****',
          alwaysShowMask: true,
          allowNegative: false
        },{
          inputType: inputTypes.INPUT_MASK_NUMBER,
          label: 'Tarif (%)',
          key: 'tarifPajak',
          thousandSeparator: '.',
          decimalSeparator: ',',
          isNumericString: true,
          validation: 'required|numeric'
        },{
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text'
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          data = Utils.formNormalize(data)
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/tarif-pph-29')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(TarifPph29Form))
